var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 57,
    rx: 12,
    fill: "#FEC10D",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6665 16V21.3333C35.6665 22.0697 36.2635 22.6667 36.9998 22.6667H42.3332",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6665 16V21.3333C35.6665 22.0697 36.2635 22.6667 36.9998 22.6667H42.3332",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6665 40H26.3332C24.8604 40 23.6665 38.8061 23.6665 37.3333V18.6667C23.6665 17.1939 24.8604 16 26.3332 16H35.6665L42.3332 22.6667V37.3333C42.3332 38.8061 41.1393 40 39.6665 40Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6665 40H26.3332C24.8604 40 23.6665 38.8061 23.6665 37.3333V18.6667C23.6665 17.1939 24.8604 16 26.3332 16H35.6665L42.3332 22.6667V37.3333C42.3332 38.8061 41.1393 40 39.6665 40Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.3307H30.3333",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.3307H30.3333",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.3307H37",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.3307H37",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 34.6667H37.0002",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 34.6667H37.0002",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDocument);
export default __webpack_public_path__ + "static/media/loan_document.a11c589c283f5cbb3629f1a9a21482a5.svg";
export { ForwardRef as ReactComponent };